import type { OrgSummary } from './api'

/** Активная организация: по id, иначе первая, иначе undefined. */
export function pickActiveOrg(
  orgs: OrgSummary[],
  activeId: number | null | undefined,
): OrgSummary | undefined {
  if (orgs.length === 0) return undefined
  if (activeId != null) {
    const found = orgs.find(o => o.org_id === activeId)
    if (found) return found
  }
  return orgs[0]
}

/**
 * Нужно ли досинхронизировать токен на первую организацию.
 *
 * Токен без active_org_id (выдан до назначения кабинета) при уже существующем
 * членстве → org-скоупные эндпоинты отвечают 403, слои/виды молча пустеют.
 * Возвращает org_id для switchOrg, иначе null (нечего/рано синхронизировать).
 */
export function orgToAutoSync(
  orgs: OrgSummary[],
  activeId: number | null | undefined,
  isLoading: boolean,
): number | null {
  if (isLoading || activeId != null || orgs.length === 0) return null
  return orgs[0].org_id
}
